<template>
<v-sheet
    class="mx-auto my-6"
    max-width="100%"
  >
    <v-slide-group
      show-arrows
      touchless
    >
      <v-slide-item
        v-for="(itemPatro , n) in aPatrocinio"
        :key="n"
      >
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn class="mx-2" depressed small text plain link tile width="150px" height="150px"
            :href="itemPatro.url_link" target="_blank"  v-bind="attrs"
            v-on="on"
            >
            <img :src="itemPatro.logo" width="100px" v-if="!itemPatro.logo == ''" :alt="itemPatro.desc_link">
            <v-icon dark color="primary" width="150px" v-else>mdi-office-building-marker-outline</v-icon>
          </v-btn>
        </template>
        <span>{{itemPatro.desc_link}}</span>
      </v-tooltip>

      </v-slide-item>
    </v-slide-group>
  </v-sheet>
</template>
<script>
import axios from 'axios'
export default {
  name: 'secLogosPatrocinio',
  data () {
    return {
      aPatrocinio: []
    }
  },
  created () {
    axios
      .get('' + this.$store.state.rutaApi + 'links_categoria')
      .then(response => (this.aPatrocinio = response.data))
  }
}
</script>
